import {
  ImageMarqueeItemsOne,
  ImageMarqueeItemsTwo,
  ImageMarqueeItemsThree,
} from './data';
import { generateDesktopSourcesForPicture } from '@farmersdog/corgi-x';
import { ImageMarquee } from './ImageMarquee';
import styles from './ImageMarqueeDesktop.module.css';
import { useState, useCallback, useEffect } from 'react';

export const ImageMarqueeDesktop = () => {
  const [isPaused, setIsPaused] = useState(true);

  const handlePause = useCallback(() => {
    setIsPaused(true);
  }, []);
  const handleResume = useCallback(() => {
    setIsPaused(false);
  }, []);

  const assetsForFirstMarquee = ImageMarqueeItemsOne.map((item, index) => ({
    ...item,
    sources: generateDesktopSourcesForPicture(item.sources),
    index,
  }));

  const assetsForSecondMarquee = ImageMarqueeItemsTwo.map((item, index) => ({
    ...item,
    sources: generateDesktopSourcesForPicture(item.sources),
    index,
  }));

  const assetsForThirdMarquee = ImageMarqueeItemsThree.map((item, index) => ({
    ...item,
    sources: generateDesktopSourcesForPicture(item.sources),
    index,
  }));

  useEffect(() => {
    setTimeout(() => {
      setIsPaused(false);
    }, 150);
  }, []);

  const marqueeSpeed = 20;

  return (
    <div
      className={styles.root}
      onMouseEnter={handlePause}
      onMouseLeave={handleResume}
      onTouchStart={handlePause}
      onTouchEnd={handleResume}
      role="region"
      aria-label={`Scrolling images of dogs with The Farmers Dog. ${isPaused ? 'Marquee paused' : 'Marquee scrolling'}`}
      aria-live="polite"
    >
      <ImageMarquee
        direction="up"
        items={assetsForFirstMarquee}
        isPaused={isPaused}
        speed={marqueeSpeed}
      />
      <ImageMarquee
        direction="down"
        items={assetsForSecondMarquee}
        isPaused={isPaused}
        speed={marqueeSpeed}
      />
      <ImageMarquee
        direction="up"
        items={assetsForThirdMarquee}
        isPaused={isPaused}
        speed={marqueeSpeed}
      />
    </div>
  );
};
